<template>
	<div class="project__details__child">
		<p class="title__status" v-if="title" @click="isOpen = !isOpen">
			<span class="title" v-html="title"></span>
			<span v-if="!isOpen" class="status">&plus;</span>
			<span v-else class="status open">&plus;</span>
		</p>
		<p class="description" v-if="description && isOpen == true" v-html="description"></p>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isOpen: false,
		};
	},

	props: {
		title: {},
		description: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.project__details__child {
	margin-bottom: 5px;

	.title__status {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 0;
		padding: 15px 10px;
		background: #f2f2f2;
		transition: 0.2s ease all;
		font-weight: bold;

		&:hover {
			background: lighten(#f2f2f2, 2);
			cursor: pointer;
		}

		.status {
			color: $signs-pink;
			margin-left: 10px;
			transition: 0.2s ease all;

			&.open {
				transform: rotate(45deg);
				color: $signs-pink;
			}
		}
	}

	.description {
		margin: 10px 0 15px;
	}
}

.slide-fade-enter-active {
	transition: opacity 0.2s ease;
	transition-delay: 0.3s;
}

.slide-fade-leave-active {
	transition: opacity 0.2s cubic-bezier(1, 0.5, 0.8, 1);
	// transition-delay: .4s;
}

.slide-fade-enter,
.slide-fade-leave-to {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/ProjectDetailsChild.vue